import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { ManageUserEditSearch, ManageUserFormPageInitialData } from "./manageUserFormPageInitialData";

const EDIT_OCC_PATH = "/page-data/my-company/organization-management/manage-users/edit";
const CREATE_OCC_PATH = "/page-data/my-company/organization-management/manage-users/create";

function buildEditPath(search: ManageUserEditSearch): string {
  const params = new URLSearchParams();
  if (search.user !== undefined) {
    params.set("user", search.user);
  }
  const query = params.toString();
  return `${EDIT_OCC_PATH}${query ? `?${query}` : ""}`;
}

export const manageUserEditPageQueryOptions = (search: ManageUserEditSearch) =>
  queryOptions({
    queryKey: [...pageDataKeys.page(EDIT_OCC_PATH), search],
    queryFn: () => fetchOccPageData<PageInitialDataResult<ManageUserFormPageInitialData>>(buildEditPath(search)),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });

export const manageUserCreatePageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page(CREATE_OCC_PATH),
    queryFn: () => fetchOccPageData<PageInitialDataResult<ManageUserFormPageInitialData>>(CREATE_OCC_PATH),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
